import {hangPromise} from "@irati/utils/promise"

interface SSOReturn {
  accessToken: string
}

interface SSOOptions {
  useRedirect: boolean
}

export const initiateSSOLogin = (url: string, options: SSOOptions): Promise<SSOReturn> => {
  if (options.useRedirect) {
    return redirect(url)
  }

  return popup(url)
}

function popup(url: string): Promise<SSOReturn> {
  const workOSPopUp = window.open("/empty-loader.html", "workOSWindow", "width=400, height=600")

  return new Promise((resolve, reject) => {
    if (!workOSPopUp) {
      return reject("Popup failed to load")
    }

    const handleSuccess = (data) => {
      const error = data?.data?.error
      const access_token = data?.data?.access_token

      if (error) {
        workOSPopUp.close()
        reject(error)
        window.removeEventListener("message", handleSuccess)
      }
      if (access_token) {
        workOSPopUp.close()
        resolve({accessToken: access_token})
        window.removeEventListener("message", handleSuccess)
      }
    }
    workOSPopUp.location = url
    window.addEventListener("message", handleSuccess)
  })
}

function redirect(url: string): Promise<SSOReturn> {
  window.location = url
  return hangPromise()
}
